export const LOADING_ELEARN = "LOADING_ELEARN";

export const POST_ADMIN = "POST_ADMIN";

export const GET_USER = "GET_USER";
